import React, { useState, useEffect } from 'react';
import HeaderTopSection from '../components/partials/HeaderTop';
import Footer from "../components/partials/Footer";
import ServiceCarousel from "../components/partials/carouselHomePage/ServiceCarousel";
import TestimonialsCarousel from '../components/partials/carouselHomePage/TestimonialsCarousel';
import BannerCarousel from "../components/partials/carouselHomePage/BannerCarousel";
import FaqSection from "../components/partials/carouselHomePage/FaqSection";
import ParcelSection from "../components/partials/carouselHomePage/ParcelSection";
import AboutSection from "../components/partials/carouselHomePage/AboutSection";
import AboutSection2 from "../components/partials/carouselHomePage/AboutSection2";
import LoadingSpinner from "../utils/LoadingSpinner";

const MainContent = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Simuler le chargement des ressources
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 3000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            {/* Affichage du spinner de chargement */}
            <LoadingSpinner
                isVisible={isLoading}
                loadingText="Chargement de la page..."
            />

            {/*<HeaderSection/>*/}
            <HeaderTopSection/>
            {/*<Preloader />*/}

            <main className="main overflow-hidden">

                {/* Banner start */}
                <BannerCarousel/>
                {/* Banner End */}

                {/* Section Percel */}
                <ParcelSection/>
                {/* Section Percel End */}

                {/* Section About */}
                <AboutSection/>
                {/* Section About End */}

                {/* Section About */}
                <AboutSection2/>
                {/* Section About End */}

                {/* Service start */}
                <ServiceCarousel/>
                {/* Service End */}

                {/* Partner start */}
                {/*<PartnerCarousel/>*/}
                {/* Partner  End */}

                {/* Counter06 start */}
                <section className="counter-section06">
                    <div className="container">
                        <div className="counter-wrapper6">
                            {/* Nombre d'employés */}
                            <div className="counter-single-item6 d-center">
                                <div className="box text-center">
                                    <div className="counters mb-2">
                                        <h3 className="odometer n900-clr">700+</h3>
                                    </div>
                                    <span className="fw-semibold n900-clr d-block mb-xl-4 mb-3">Professionel</span>
                                    <a href="about.html" className="n900-clr">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </a>
                                </div>
                            </div>
                            {/* Nombre de partenaires */}
                            <div className="counter-single-item6 d-center">
                                <div className="box text-center">
                                    <div className="counters mb-2">
                                        <h3 className="odometer n900-clr">4+</h3>
                                    </div>
                                    <span className="fw-semibold n900-clr d-block mb-xl-4 mb-3">Partenaires</span>
                                    <a href="partners.html" className="n900-clr">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </a>
                                </div>
                            </div>
                            {/* Nombre de projets réalisés */}
                            <div className="counter-single-item6 d-center">
                                <div className="box text-center">
                                    <div className="counters mb-2">
                                        <h3 className="odometer n900-clr">2000+</h3>
                                    </div>
                                    <span className="fw-semibold n900-clr d-block mb-xl-4 mb-3">Projets Réalisés</span>
                                    <a href="projects.html" className="n900-clr">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </a>
                                </div>
                            </div>
                            {/* Nombre de clients satisfaits */}
                            <div className="counter-single-item6 d-center">
                                <div className="box text-center">
                                    <div className="counters mb-2">
                                        <h3 className="odometer n900-clr">95%</h3>
                                    </div>
                                    <span className="fw-semibold n900-clr d-block mb-xl-4 mb-3">Clients Satisfaits</span>
                                    <a href="testimonials.html" className="n900-clr">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* Counter06 End */}

                {/* Experties start */}
                <TestimonialsCarousel/>
                {/* Experties End */}

                {/* Faq start */}
                <FaqSection/>
                {/* Faq End */}
            </main>

            <Footer/>
        </>
    );
};

export default MainContent;